/**
 * Only return property values where the value has changed
 */
export const valueDiff = <T>(values: Partial<T>[]): Partial<T> => {
    const diff: Partial<T> = {};

    if (values.length !== 2) throw new Error('Need 2 inputs');

    const oldValue = values[0];
    const newValue = values[1];

    for (const key in oldValue) {
        // eslint-disable-next-line no-prototype-builtins
        if (!oldValue.hasOwnProperty(key)) {
            continue;
        }

        if (Array.isArray(oldValue[key])) {
            if (!Array.isArray(newValue[key])) {
                diff[key] = undefined;
            } else {
                diff[key] = (oldValue[key] as any[]).filter((x) => (newValue[key] as any[]).includes(x)) as T[Extract<
                    keyof T,
                    string
                >];
            }
        } else if (oldValue[key] !== newValue[key]) {
            // Check if value change occured
            diff[key] = newValue[key];
        }
    }

    return diff;
};
